import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';
//import { Response } from "@angular/http"
import { Observable } from 'rxjs';
import { User } from '../../model/user.model';
import { BehaviorSubject } from 'rxjs';
import { ReplaySubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { distinctUntilChanged } from 'rxjs/operators';
import { JwtService } from '../../auth/jwt.service';
import { DataSharingService } from '../../auth/data-sharing.service';
import { HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
//import { COMMON_DEPRECATED_I18N_PIPES } from '@angular/common/src/pipes/deprecated';

export interface UserLogin {
  Email: string;
  Password: string;
}

export interface UserAccessToken {
  AccessToken: string;
}

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private currentUserSubject = new BehaviorSubject<User>({} as User);
  public currentUser = this.currentUserSubject.asObservable().pipe(distinctUntilChanged());

  private isAuthenticatedSubject = new ReplaySubject<boolean>(1);
  public isAuthenticated = this.isAuthenticatedSubject.asObservable();

  public isUserAdmin: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isUserVendor: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isUserFinance: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isUserPurchase: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isUserSiteinc: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isUserTransport: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);


  public roleRowsState: BehaviorSubject<number> = new BehaviorSubject<number>(5);
  public currentCompany: BehaviorSubject<string> = new BehaviorSubject<string>("");



  //readonly rootUrl = "";
  readonly rootUrl = environment.baseUrl;

  constructor(private http: HttpClient, private jwtService: JwtService,
    private dataSharingService: DataSharingService) {
    this.populateUserData();
  }

  getOriginalReValue(id, clip, reValue, secretKey, clientLinkId, EnteredUrl) {
    debugger;
    const model = {
      ProjectId: id,
      ClipId: clip,
      REValue: reValue,
      SecretKey: secretKey,
      ClientlinkId: clientLinkId,
      URL: EnteredUrl,
      offset: new Date().getTimezoneOffset()
    }

    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
      'No-Auth': 'True'
    };
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    return this.http.post(this.rootUrl + 'api/account/ValidateRE', model, requestOptions);
  }

  registerUser(user) {

    // const body: User = {
    //   Email: user.Email,
    //   Password: user.Password,
    //   ConfirmPassword: user.ConfirmPassword,
    //   PhoneNumber: user.PhoneNumber,
    //   Address: user.Address,
    //   userType: user.userType,
    //   FullName: user.FullName,
    //   VendorCode: user.VendorCode,
    //   type: user.type,
    //   IsActive: user.IsActive,
    //   CreatedBy: user.CreatedBy,
    //   CreatedOn: user.CreatedOn,
    //   UpdatedBy: user.UpdatedBy,
    //   UpdatedOn: user.UpdatedOn,
    //   RegisterCode: user.RegisterCode,
    //   Error: user.Error
    // }

    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
      'No-Auth': 'True'
    };
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    return this.http.post(this.rootUrl + '/api/Account/Register', user, requestOptions);

  }

  userAuthentication(userName, password) {

    let userLogin: UserLogin = {
      Email: userName,
      Password: password
    };

    var data = "Email=" + userName + "&Password=" + password;

    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
      'No-Auth': 'True'
    };
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded' });
    return this.http.post(this.rootUrl + '/api/Account/Login', userLogin, requestOptions);

  }

  setAuth(user: User) {
    //Set Loggedin status to true in data sharing
    this.dataSharingService.isUserLoggedIn.next(true);
    // Set current user data into observable
    this.currentUserSubject.next(user);
    // Set isAuthenticated to true
    this.isAuthenticatedSubject.next(true);

    if (user.userType == "1" && user.type == "Admin") {
      this.isUserAdmin.next(true);
    } else if (user.userType == "2" && user.type == "Vendor") {
      this.isUserVendor.next(true);
    }
    else if (user.userType == "3" && user.type == "Purchase") {
      this.isUserPurchase.next(true);
    }
    else if (user.userType == "4" && user.type == "Finance") {
      this.isUserFinance.next(true);
    }
    else if (user.userType == "5" && user.type == "SiteIncharge") {
      this.isUserSiteinc.next(true);
    }
    else if (user.userType == "6" && user.type == "TransportManager") {
      this.isUserTransport.next(true);
    }
    else {
      this.purgeAuth();
    }

  }

  populateUserData() {
    if (localStorage.getItem("userToken") != null) {
      var accessTokens = localStorage.getItem("userToken");
      this.getCurrentUserData(accessTokens).subscribe((data: any) => {
        if (data.accessToken != null && data != "false") {
          //localStorage.setItem('userToken', data.accessToken);
          //this.jwtService.saveToken(data.accessToken);
          this.setAuth(data);
        }
        else {

        }

      },
        (err: HttpErrorResponse) => {

        });

    }
    else {

    }
  }

  getCurrentUserData(accessTokens) {

    let acesTokn: UserAccessToken = {
      AccessToken: accessTokens
    };

    var data = "AccessToken=" + accessTokens;

    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type'
    };
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded' });
    return this.http.post(this.rootUrl + '/api/Account/getCurrentUserData', acesTokn, requestOptions);
    //return this.http.get(this.rootUrl + '/api/Account/getCurrentUserData');


  }

  purgeAuth() {

    this.dataSharingService.isUserLoggedIn.next(false);
    // Remove JWT from localstorage
    this.jwtService.destroyTokenOrType();
    // Set current user to an empty object
    this.currentUserSubject.next({} as User);
    // Set auth status to false
    this.isAuthenticatedSubject.next(false);

    this.isUserAdmin.next(false);
    this.isUserSiteinc.next(false);
    this.isUserVendor.next(false);
    this.isUserPurchase.next(false);
    this.isUserFinance.next(false);
    this.isUserTransport.next(false);

  }
  getUsersData() {
    return this.http.get(this.rootUrl + '/api/account/getUsersData');
  }

  getRoleValue() {
    return this.http.get(this.rootUrl + '/api/account/getRoleValue');
  }

  getCountryList() {
    return this.http.get(this.rootUrl + '/api/account/getCountryList');
  }

  getProjectSpecificCountryList(pid) {
    const searchForm = {
      projectId: pid,
    }
    return this.http.post(this.rootUrl + '/api/account/getProjectSpecificCountryList', searchForm);
  }

  getLanguageList() {
    return this.http.get(this.rootUrl + '/api/account/getLanguageList');
  }
  GetUsedLinks(pId, cId, langId) {
    const searchForm = {
      projectid: pId,
      CountryId: cId,
      LanguageId: langId
    }
    return this.http.post(this.rootUrl + '/api/Role/GetUsedLinks', searchForm);
  }
  getAssignTeamsToProject(pid) {
    const searchForm = {
      projectId: pid,
    }
    return this.http.post(this.rootUrl + '/api/account/getAssignTeamsToProject', searchForm);
  }
  getTeamMemberList() {
    return this.http.get(this.rootUrl + '/api/account/getTeamMemberList');
  }

  getLanguageListForSurvey(projectId, countryId) {
    const project = {
      projectId: projectId,
      countryid: countryId
    }
    return this.http.post(this.rootUrl + '/api/account/getLanguageListForSurvey', project);
  }
  getAssignedProjects(projectId, CurrentUserId) {
    const project = {
      projectId: projectId,
      CurrentUserId: CurrentUserId
    }
    return this.http.post(this.rootUrl + '/api/account/getAssignedProjects', project);
  }

  getVendorList() {
    return this.http.get(this.rootUrl + '/api/account/getVendorList');
  }


  resetpassword(form) {
    debugger;
    return this.http.post(this.rootUrl + '/api/account/ResetPassword', form);
  }

  saveAnswers(answers) {
    debugger;
    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
      'No-Auth': 'True'
    };
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    return this.http.post(this.rootUrl + '/api/account/saveAnswers', answers, requestOptions);
  }
  getUserProfile() {
    return this.http.get(this.rootUrl + '/api/account/getUserProfile');
  }
  EditSiteUser(id) {

    const user = {
      userId: id
    }
    return this.http.post(this.rootUrl + '/api/account/editSiteUser', user);
  }

  addQuestion(question) {
    debugger;
    const questions = {
      title: question.title,
      type: question.questiontype,
      noofoptions: question.noofoptions,
      projectId: question.projectId,
      vendID: question.vendID,
      Ans: question.ansString,
      CorrectAns: question.correctAns,
    }
    return this.http.post(this.rootUrl + '/api/account/addQuestions', questions);
  }
  GetLangList(pid, cid) {
    const searchForm = {
      projectId: pid,
      countryid: cid,
    }
    return this.http.post(this.rootUrl + '/api/Role/GetLangList', searchForm);
  }

  GetUnassignedLink(pid, cid, lid, projectCalculationId) {
    const searchForm = {
      projectId: pid,
      countryid: cid,
      langid: lid,
      ProjectCalculationId: projectCalculationId,
    }
    return this.http.post(this.rootUrl + '/api/Role/GetUnassignedLink', searchForm);
  }

  getAllProjectCalculationByLangCountry(pid, cid, lid, type) {
    const general = {
      projectId: pid,
      countryid: cid,
      langid: lid,
      type: type
    }
    return this.http.post(this.rootUrl + '/api/account/getAllProjectCalculationByLangCountry', general);
  }

  editcountrychecks(pid, lid, cid) {
    debugger;
    const questions = {
      langid: lid,
      countryid: cid,
      projectId: pid,
    }
    return this.http.post(this.rootUrl + '/api/account/editcountrychecks', questions);
  }

  updateCountryCheck(project) {
    debugger;

    const isFromTimeValid = project.selectedFromHour && project.selectedFromMinute && project.selectedFromAmpm;
    const isToTimeValid = project.selectedToHour && project.selectedToMinute && project.selectedToAmpm;
    const questions = {
      langid: project.languageid,
      countryid: project.countryid,
      projectId: project.projectid,
      custompage: project.custompage,
      fingerprintsecurity: project.fingerprintsecurity,
      geoiplocation: project.geoiplocation,
      ipsecurity: project.ipsecurity,
      captcha: project.recaptcha,
      questionnaire: project.questionnaire,
      mobile: project.mobile,
      isActiveLocalTimeZone: project.isActiveLocalTimeZone,
      //invisiblerecaptcha: project.invisiblerecaptcha,
      waitingTime: project.waitingTime,
      openstarttime: isFromTimeValid
        ? `${project.selectedFromHour}:${project.selectedFromMinute} ${project.selectedFromAmpm}`
        : null,

      openclosetime: isToTimeValid
        ? `${project.selectedToHour}:${project.selectedToMinute} ${project.selectedToAmpm}`
        : null,
    }
    console.log(questions);
    return this.http.post(this.rootUrl + '/api/account/updateCountryCheck', questions);
  }


  getQuestionForProject(id, clid) {
    debugger;
    const questions = {
      projectId: id,
      clid: clid,
    }

    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
      'No-Auth': 'True'
    };
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    return this.http.post(this.rootUrl + '/api/account/getQuestionForProject', questions, requestOptions);
  }

  getQuotaFullStatus(id, clid) {
    debugger;
    const questions = {
      projectId: id,
      clid: clid,
    }

    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
      'No-Auth': 'True'
    };
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    return this.http.post(this.rootUrl + '/api/account/getQuotaFullStatus', questions, requestOptions);
  }

  getCatchaQuestionnaireCheck(id, clid) {
    debugger;
    const questions = {
      projectId: id,
      clid: clid,
    }

    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
      'No-Auth': 'True'
    };
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    return this.http.post(this.rootUrl + '/api/account/getCatchaQuestionnaireCheck', questions, requestOptions);
  }

  surveyUrl(id, clid, clip, re, status, ClientLinkKey, isSentryStatusExist, sentryStatus) {
    debugger;
    const questions = {
      projectId: id,
      clip: clip,
      clid: clid,
      re: re,
      status: status,
      ClientLinkKey: ClientLinkKey,
      isSentryStatusExist: isSentryStatusExist,
      sentryStatus: sentryStatus
    }

    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
      'No-Auth': 'True'
    };
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };


    return this.http.post(this.rootUrl + '/api/account/surveyUrl', questions, requestOptions);
  }

  InsertQuotaFullRecord(id, clid, clip, re, status, ClientLinkKey, isSentryStatusExist, sentryStatus) {
    debugger;
    const questions = {
      projectId: id,
      clip: clip,
      clid: clid,
      re: re,
      status: status,
      ClientLinkKey: ClientLinkKey,
      IsSentryStatusExist: isSentryStatusExist,
      SentryStatus: sentryStatus
    }

    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
      'No-Auth': 'True'
    };
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };


    return this.http.post(this.rootUrl + '/api/account/InsertQuotaFullRecord', questions, requestOptions);
  }

  MarkSurveyTerminated(id, clid, clip, re, status) {
    debugger;
    const questions = {
      projectId: id,
      clip: clip,
      clid: clid,
      re: re,
      status: status,
    }

    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
      'No-Auth': 'True'
    };
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };


    return this.http.post(this.rootUrl + '/api/account/MarkSurveyTerminated', questions, requestOptions);
  }

  getVendorUrls(id) {
    debugger;
    const questions = {
      projectId: id,
    }

    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
      'No-Auth': 'True'
    };
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };


    return this.http.post(this.rootUrl + '/api/account/getVendorUrls', questions, requestOptions);
  }

  continueClick(id, clid, clip, re) {
    debugger;
    const questions = {
      projectId: id,
      clip: clip,
      clid: clid,
      re: re
    }
    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
      'No-Auth': 'True'
    };
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    return this.http.post(this.rootUrl + '/api/account/continueClick', questions, requestOptions);
  }

  addClientLinkData(data, projectSecurityId) {
    debugger;

    const Data = {
      projectId: data.projectid,
      target: data.target,
      optimisticcount: data.optimisticcount,
      countryid: data.countryid,
      langid: data.langaugeid,
      clientlink: data.surveylink,
      custompage: data.custompage,
      fingerprintsecurity: data.fingerprintsecurity,
      geoiplocation: data.geoiplocation,
      ipsecurity: data.ipsecurity,
      set: data.set,
      securityid: projectSecurityId
    }
    return this.http.post(this.rootUrl + '/api/account/addClientLinkData', Data);
  }

  addClientLinkDataForMultiple(data, filelist, projectSecurityId) {
    const Data = {
      projectId: data.projectid,
      target: data.target,
      optimisticcount: data.optimisticcount,
      countryid: data.countryid,
      langid: data.langaugeid,
      clientlink: data.surveylink,
      custompage: data.custompage,
      fingerprintsecurity: data.fingerprintsecurity,
      geoiplocation: data.geoiplocation,
      ipsecurity: data.ipsecurity,
      set: data.set,
      multiplesurveylink: filelist,
      securityid: projectSecurityId
    }
    return this.http.post(this.rootUrl + '/api/account/addClientLinkDataForMultiple', Data);
  }

  addProjectDetails(data) {
    debugger;

    const Data = {
      projectId: data.projectid,
      target: data.quotatarget,
      optimisticcount: data.optimisticcount,
      countryid: data.country,
      langid: data.language,
      projectdescription: data.projectdescription,
      projectname: data.projectname,
      proposalCode:data.proposalCode,
      clientname: data.clientname,
      vendcomprefirecturl: data.complete,
      vendtermredirecturl: data.terminate,
      vendqfredirecturl: data.qf,
      vendqcrredirecturl: data.qcreject,
      teamMember: data.teamMember.join(','),
    }
    return this.http.post(this.rootUrl + '/api/account/addProjectDetails', Data);
  }

  addProjectSecurityDetails(data) {
    debugger;

    const isFromTimeValid = data.selectedFromHour && data.selectedFromMinute && data.selectedFromAmpm;
    const isToTimeValid = data.selectedToHour && data.selectedToMinute && data.selectedToAmpm;


    const Data = {
      projectId: data.projectid,
      countryid: data.country,
      langid: data.language,
      projectdescription: data.projectdescription,
      projectname: data.projectname,
      clientname: data.clientname,
      custompage: data.custompage,
      fingerprintsecurity: data.fingerprintsecurity,
      geoiplocation: data.geoiplocation,
      ipsecurity: data.ipsecurity,
      captcha: data.recaptcha,
      questionnaire: data.questionnaire,
      mobile: data.mobile,
      //invisiblerecaptcha  : data.invisiblerecaptcha,
      waitingTime: data.waitingTime,
      isActiveLocalTimeZone: data.isActiveLocalTimeZone,
      teamMember: data.teamMember.join(','),
      openstarttime: isFromTimeValid
        ? `${data.selectedFromHour}:${data.selectedFromMinute} ${data.selectedFromAmpm}`
        : null,

      openclosetime: isToTimeValid
        ? `${data.selectedToHour}:${data.selectedToMinute} ${data.selectedToAmpm}`
        : null,
    }
    return this.http.post(this.rootUrl + '/api/account/addProjectSecurityDetails', Data);
  }

  updateProjectStatus(data) {
    debugger;
    const Data = {
      projectId: data.projectid,
      custommessage: data.customMessage || "",
      custompage: data.custompage || false,
      fingerprintsecurity: data.fingerprintsecurity || false,
      geoiplocation: data.geoiplocation || false,
      ipsecurity: data.ipsecurity || false,
      projectmode: data.projectMode,
      captcha: data.recaptcha || false,
      questionnaire: data.questionnaire || false,
      mobile: data.mobile || 1,
      isRDEnabled: data.isRDEnabled || false,
      isActivityEnabled: data.isActivityEnabled || false,
      invisiblerecaptcha: data.invisiblerecaptcha || false,
      waitingTime: data.waitingTime,
      teamMember: data.teamMember.join(','),
    }
    return this.http.post(this.rootUrl + '/api/account/updateProjectStatus', Data);
  }

  updateProjectLog(data) {
    debugger;
    const Data = {
      projectId: data.projectid,
      custommessage: data.customMessage || "",
      custompage: data.custompage || false,
      fingerprintsecurity: data.fingerprintsecurity || false,
      geoiplocation: data.geoiplocation || false,
      ipsecurity: data.ipsecurity || false,
      captcha: data.recaptcha || false,
      questionnaire: data.questionnaire || false,
      mobile: data.mobile || 1,
      projectmode: data.projectMode,
      isRDEnabled: data.isRDEnabled || false,
      isActivityEnabled: data.isActivityEnabled || false,
      invisiblerecaptcha: data.invisiblerecaptcha || false,
    }
    console.log(data);
    return this.http.post(this.rootUrl + '/api/account/updateProjectLog', Data);
  }

  addVendorClipData(data, securityId, clientLinkId, projectCalculationId) {
    debugger;
    const Data = {
      projectId: data.projectid,
      clip: data.vendorclip,
      vendorid: data.vendorname,
      countryid: data.countryid,
      langid: data.langid,
      set: data.set,
      vendcomprefirecturl: data.VendCompRedirectURL,
      vendtermredirecturl: data.VendTermRedirectURL,
      vendqfredirecturl: data.VendQFRedirectURL,
      vendqcrredirecturl: data.VendQCRRedirectURL,
      url: data.url,
      securityid: securityId,
      clientlinkid: clientLinkId,
      ProjectCalculationId: projectCalculationId
    }
    return this.http.post(this.rootUrl + '/api/account/addVendorClipData', Data);
  }

  addOldVendorClipData(data, securityId, clientLinkId, projectCalculationId) {
    debugger;
    const Data = {
      projectId: data.projectid,
      clip: data.vendorclip,
      vendorid: data.vendorname,
      countryid: data.countryid,
      langid: data.langid,
      set: data.set,
      vendcomprefirecturl: data.VendCompRedirectURL,
      vendtermredirecturl: data.VendTermRedirectURL,
      vendqfredirecturl: data.VendQFRedirectURL,
      vendqcrredirecturl: data.VendQCRRedirectURL,
      url: data.url,
      securityid: securityId,
      clientlinkid: clientLinkId,
      ProjectCalculationId: projectCalculationId
    }
    return this.http.post(this.rootUrl + '/api/account/addOldVendorClipData', Data);
  }


  addVendorClipDataForMultiple(data, num, securityId, clientLinkId, projectCalculationId) {
    debugger;
    const Data = {
      projectId: data.projectid,
      clip: data.vendorclip,
      vendorid: data.vendorname,
      countryid: data.countryid,
      langid: data.langid,
      set: data.set,
      vendcomprefirecturl: data.VendCompRedirectURL,
      vendtermredirecturl: data.VendTermRedirectURL,
      vendqfredirecturl: data.VendQFRedirectURL,
      vendqcrredirecturl: data.VendQCRRedirectURL,
      url: data.url,
      assignlink: data.assignlink,
      totalLink: num,
      securityid: securityId,
      clientlinkid: clientLinkId,
      ProjectCalculationId: projectCalculationId
    }
    return this.http.post(this.rootUrl + '/api/account/addVendorClipDataForMultiple', Data);
  }

  addVendorData(data) {
    debugger;
    const Data = {
      vendorid: data.vendorname,
      vendcomprefirecturl: data.scurl,
      vendtermredirecturl: data.sturl,
      vendqfredirecturl: data.sqfurl,
      vendqcrredirecturl: data.sqcrurl,
    }
    return this.http.post(this.rootUrl + '/api/account/addVendorData', Data);
  }

  checkIfClipExist(data) {
    debugger;
    const Data = {
      projectId: data.projectid,
      clip: data.vendorclip,
    }
    return this.http.post(this.rootUrl + '/api/account/checkIfClipExist', Data);
  }



  getProjectCalculationDetails(id) {
    debugger;
    const general = {
      projectId: id,
    }
    return this.http.post(this.rootUrl + '/api/account/getProjectCalculationDetails', general);
  }

  getSecurityIdFromProjectCalculation(id, projectid) {
    debugger;
    const general = {
      projectCalculationId: id,
      projectid: projectid
    }
    return this.http.post(this.rootUrl + '/api/account/getSecurityIdFromProjectCalculation', general);
  }

  getClientLinkIdFromClientLink(securityId, clientLinkKey, countryid, langid, projectid) {
    debugger;
    const Data = {
      securityid: securityId,
      clientLinkKey: clientLinkKey,
      countryid: countryid,
      langid: langid,
      projectid: projectid
    }
    return this.http.post(this.rootUrl + '/api/account/getClientLinkIdFromClientLink', Data);
  }

  getProjectLog(id) {
    debugger;
    const general = {
      projectId: id,
    }
    return this.http.post(this.rootUrl + '/api/account/getProjectLog', general);
  }

  getSubmitAnswers(id) {
    debugger;
    const general = {
      projectId: id,
    }
    return this.http.post(this.rootUrl + '/api/account/getSubmitAnswers', general);
  }

  getClientSurveyErrorLogs(id) {
    debugger;
    const general = {
      projectId: id,
    }
    return this.http.post(this.rootUrl + '/api/account/getClientSurveyErrorLogs', general);
  }


  // addAnswers(answer:string,projectId,vendID,correctans) {
  //   debugger;
  //   const answers = {
  //     Ans:answer,
  //     projectId:projectId,
  //     vendID:vendID,
  //     CorrectAns:correctans,
  //   }
  //   return this.http.post(this.rootUrl + '/api/account/addAnswers', answers);
  // }

  submitSiteUserForm(form) {
    return this.http.post(this.rootUrl + '/api/account/submitSiteUserForm', form);
  }
  removeSiteUser(id) {
    const user = {
      userId: id
    }
    return this.http.post(this.rootUrl + '/api/account/removeSiteUser', user);
  }
  GetMessagelist() {
    return this.http.get(this.rootUrl + '/api/account/GetMessagelist');
  }
  Deletemessage(userId) {
    debugger;
    const msg = {
      id: userId
    }
    return this.http.post(this.rootUrl + '/api/account/deletemessage', msg);
  }

  searchVendor(keywrd) {
    const key = {
      keyword: keywrd
    }
    return this.http.post(this.rootUrl + '/api/account/SearchVendor', key);
  }

  searchProject(keywrd) {
    const key = {
      keyword: keywrd
    }
    return this.http.post(this.rootUrl + '/api/account/SearchProject', key);
  }

  searchProjectFromMyDashboard(keywrd) {
    const key = {
      keyword: keywrd
    }
    return this.http.post(this.rootUrl + '/api/account/searchProjectFromMyDashboard', key);
  }

  moveProjectDetailToDashboard(keywrd) {
    const key = {
      keyword: keywrd
    }
    return this.http.post(this.rootUrl + '/api/account/moveProjectDetailToDashboard', key);
  }



  deleteProject(projectId) {
    const msg = {
      projectId: projectId
    }
    return this.http.post(this.rootUrl + '/api/account/deleteProject', msg);
  }

  deleteQuestion(ID) {
    const msg = {
      Id: ID
    }
    return this.http.post(this.rootUrl + '/api/account/deleteQuestion', msg);
  }

  ResetData(data, pid) {
    const msg = {
      clientlinkid: data.clientLinkID,
      target: data.target,
      optimisticcount: data.optimisticCount,
      Company: data.countryName,
      langid: data.languageID,
      projectId: pid,
    }
    return this.http.post(this.rootUrl + '/api/account/ResetData', msg);
  }

  GetDataForSentryApi(data, pid) {
    const msg = {
      clientlinkid: data.clientLinkID,
      target: data.target,
      optimisticcount: data.optimisticCount,
      countryid: data.countryId,
      langid: data.languageId,
      projectId: pid,
      vendorid: data.vendorId,
    }
    return this.http.post(this.rootUrl + '/api/account/GetDataForSentryApi', msg);
  }

  GetExistingSentryProjectId(data) {
    const msg = {
      assignedClip: data.assignedClip,
      PETProtectId: data.projectId,
      vendorName: data.vendorName,
      vendorId: data.vendorId,
    }
    return this.http.post(this.rootUrl + '/api/Sentry/GetExistingSentryProjectId', msg);
  }

  CreateSentryProject(request: any) {

    const url =
      this.rootUrl + '/api/Sentry/CreateSentryProject';

    console.log('Calling Sentry Create API:', url);
    console.log('Request:', request);

    return this.http.post<any>(
      url,
      request
    );
  }

  CheckVendorProviderExists(vendorName: string) {
    const msg = { vendorName };

    return this.http.post(
      this.rootUrl + '/api/account/CheckVendorProviderExists',
      msg
    );
  }

  UpdateSentryProject(projectId: string, request: any): Observable<any> {
    return this.http.put(
      `${this.rootUrl}/api/Sentry/UpdateSentryProject/${projectId}`,
      request
    );
  }

  GetSentryTemplate() {
    const url = this.rootUrl + '/api/Sentry/GetSentryTemplate';
    console.log("Calling:", url);
    return this.http.get(url);
  }

  //   GetSentryTemplate() {
  //   const headerDict = {
  //     'Content-Type': 'application/json',
  //     'Accept': 'application/json',
  //     'Access-Control-Allow-Headers': 'Content-Type',
  //     'No-Auth': 'True'
  //   };
  //   const requestOptions = {
  //     headers: new HttpHeaders(headerDict),
  //   };

  //   const url = this.rootUrl + '/api/Sentry/GetSentryTemplate';
  //   console.log("Calling:", url);
  //   return this.http.get(url, requestOptions);
  // }

  ResetDataForMultiple(data, pid) {
    const msg = {
      target: data.target,
      optimisticcount: data.optimisticCount,
      countryid: data.countryId,
      langid: data.languageID,
      projectId: pid,
      projectCalculationID: data.projectCalculationID
    }
    return this.http.post(this.rootUrl + '/api/account/ResetDataForMultiple', msg);
  }

  getMultipleLinkDataToExport(data, pid) {
    const msg = {
      target: data.target,
      optimisticcount: data.optimisticCount,
      countryid: data.countryId,
      langid: data.languageID,
      projectId: pid,
      clientLinkKey: data.clientLinkKey
    }
    return this.http.post(this.rootUrl + '/api/account/getMultipleLinkDataToExport', msg);
  }

  deleteClientSurveyData(archiveClientSurveyID) {
    const msg = {
      archiveClientSurveyID: archiveClientSurveyID
    }
    return this.http.post(this.rootUrl + '/api/account/deleteClientSurveyData', msg);
  }

  changeDataToComplete(archiveClientSurveyID) {
    const msg = {
      archiveClientSurveyID: archiveClientSurveyID
    }
    return this.http.post(this.rootUrl + '/api/account/changeDataToComplete', msg);
  }
  changeDataToQuotaFull(archiveClientSurveyID) {
    const msg = {
      archiveClientSurveyID: archiveClientSurveyID
    }
    return this.http.post(this.rootUrl + '/api/account/changeDataToQuotaFull', msg);
  }
  changeDataToTerminated(archiveClientSurveyID) {
    const msg = {
      archiveClientSurveyID: archiveClientSurveyID
    }
    return this.http.post(this.rootUrl + '/api/account/changeDataToTerminated', msg);
  }
  changeDataToQCRejected(archiveClientSurveyID) {
    const msg = {
      archiveClientSurveyID: archiveClientSurveyID
    }
    return this.http.post(this.rootUrl + '/api/account/changeDataToQCRejected', msg);
  }

  resetip(archiveClientSurveyID) {
    const msg = {
      archiveClientSurveyID: archiveClientSurveyID
    }
    return this.http.post(this.rootUrl + '/api/account/resetip', msg);
  }

  changeDataToInProgress(archiveClientSurveyID) {
    const msg = {
      archiveClientSurveyID: archiveClientSurveyID
    }
    return this.http.post(this.rootUrl + '/api/account/changeDataToInProgress', msg);
  }

  MoveDataToId(archiveClientSurveyID, id) {
    const msg = {
      archiveClientSurveyID: archiveClientSurveyID,
      projectid: id,
    }
    return this.http.post(this.rootUrl + '/api/account/MoveDataToId', msg);
  }


  deleteSpecificProject(projectId) {
    debugger;
    const msg = {
      projectId: projectId
    }
    return this.http.post(this.rootUrl + '/api/account/deleteSpecificProject', msg);
  }

  ForgotPassword(emailid) {
    const user = {
      email: emailid
    }

    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
      'No-Auth': 'True'
    };
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };


    return this.http.post(this.rootUrl + '/api/Account/ForgotPassword', user, requestOptions);
  }

  uploadUserData(formdata) {
    return this.http.post(this.rootUrl + '/api/Account/UploadUserData', formdata);
  }

  SendUserCredentials(id) {
    const user = {
      userId: id
    }
    return this.http.post(this.rootUrl + '/api/account/SendUserCredentials', user);
  }

  callTokenApiSearch(url) {
    const headerDict = {
      'Content-Type': 'application/json',
      'No-Auth': 'True'
    };
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    return this.http.get(url, requestOptions);
  }

  callResearchDefender(url, token) {
    const headerDict = {
      'Content-Type': 'application/json',
      'token': token,
      // 'Accept': 'application/json',
      // 'Access-Control-Allow-Headers': 'Content-Type',
      'No-Auth': 'True'
    };
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    //return this.http.get('https://prod.rtymgt.com/api/v2/respondents/search/32cb928e-c79c-4e2b-a7e6-7ea747686c61?sy_nr=P100000230&sn_ud=12482&rt_sr_pd=uheir');
    return this.http.get(url, requestOptions);
  }

  callResearchActivityApi(url, licenseKey) {
    const headerDict = {
      'Content-Type': 'application/json',
      //'Accept': 'application/json',
      //'Access-Control-Allow-Headers': 'Content-Type',
      'No-Auth': 'True'
      //'x-api-key' : licenseKey  //enable for new activity search
    };
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    //return this.http.get('https://prod.rtymgt.com/api/v2/respondents/search/32cb928e-c79c-4e2b-a7e6-7ea747686c61?sy_nr=P100000230&sn_ud=12482&rt_sr_pd=uheir');
    return this.http.get(url, requestOptions);
  }

  getResearchDefenderData(projectId) {
    var data = {
      projectid: projectId
    }

    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
      'No-Auth': 'True'
    };
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    return this.http.post(this.rootUrl + 'api/account/GetResearchDefenderDetails', data, requestOptions);
  }

  researchErrorLog(data) {

    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
      'No-Auth': 'True'
    };
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    return this.http.post(this.rootUrl + 'api/account/ResearchErrorLog', data, requestOptions);
  }

  archivesurvey(projectId: string) {
    debugger;
    const data = {
      projectId: projectId
    };

    return this.http.post(this.rootUrl + 'api/account/archivesurvey', data
    );
  }

  unarchivesurvey(projectId: string) {
  const data = {
    projectId: projectId
  };

  return this.http.post(this.rootUrl + 'api/account/unarchivesurvey', data);
}

  verifyCaptcha(data) {
    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
      'No-Auth': 'True'
    };
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    return this.http.post(this.rootUrl + 'api/account/SiteVerify', data, requestOptions);
  }

}

